export default __webpack_public_path__ + "static/media/img1.dbf49573.jpg";